var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('AppBar'),_c('MainMenu'),_c('ProfileMenu'),_c('MainPanel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }